import styled from "styled-components";

import { Swiper } from "swiper/react";
import { ColorVariables } from "../Colors";

export const SwiperDiv = styled(Swiper)`
  width: calc(100vw + 312px);
  margin-left: -156px;

  .swiper-slide {
    width: 312px;
  }

  @media (min-width: 950px) {
    width: calc(100vw + 490px);
    margin-left: -245px;

    .swiper-slide {
      width: 490px;
    }
  }
  @media (min-width: 1320px) {
    width: calc(100vw + 490px);
    margin-left: -490px;
  }
`;

export const TestimonySlide = styled.div`
  width: 100%;
  padding: 0 15px;
  height: 312px;

  @media (min-width: 950px) {
    max-width: 490px;
    padding: 0 40px;
    height: 250px;
  }
`;

export const TestimonySlideWrapper = styled.div`
  background: ${ColorVariables.mint3};
  border-radius: 16px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  height: 100%;
`;

export const TestimonySlideContent = styled.div`
  color: #2e2e2d;
  p {
    font-size: 14px;
    line-height: 1.78;
  }

  flex: 1;
  @media (min-width: 950px) {
    font-size: 15px;
  }
`;

export const TestimonySlideName = styled.div`
  p {
    font-size: 16px;
    line-height: 1.25;
    font-weight: 500;
  }
  .secondary {
    font-size: 12px;
    color: #667085;
    font-weight: 400;
  }

  @media (min-width: 950px) {
    p {
      font-size: 18px;
      line-height: 1.25;
    }
    .secondary {
      font-size: 14px;
    }
  }
`;
